<div class="upload-file">
  <div class="upload-file__header-container">
    <span class="upload-file__header-title">{{ 'upload_modal.UploadFile' | translate }}</span>
    <span class="ion-float-right">
      <img class="upload-file__close" (click)="close()" src="assets/common/cross.svg" />
    </span>
  </div>

  <div class="upload-file__content-wrpr">
    <div class="upload-file__subtitle-container">
      <span *ngIf="supportedFileType === 'XLSX'" class="upload-file__subtitle-text">{{
        'upload_modal.Onlyxlsxfilesaresupported' | translate
      }}</span>
      <span *ngIf="supportedFileType === 'PDF'" class="upload-file__subtitle-text">{{
        'upload_modal.OnlyPdffilesaresupported' | translate
      }}</span>
      <span *ngIf="downloadSampleTemplate" class="ion-float-right upload-file__subtitle-btn" (click)="downloadFile()">
        {{ 'upload_modal.DownloadSampleTemplate' | translate }}</span
      >
    </div>

    <div *ngIf="fileExtensionError" class="upload-file__error-container ion-text-center">
      <span>
        <img class="upload-file__error-img" src="assets/common/error-icon.svg" />
      </span>
      <span *ngIf="supportedFileType === 'XLSX'" class="upload-file__error-txt">{{
        'upload_modal.UploadFailedXlsx' | translate
      }}</span>
      <span *ngIf="supportedFileType === 'PDF'" class="upload-file__error-txt">{{
        'upload_modal.UploadFailedPdf' | translate
      }}</span>
    </div>

    <div class="upload-file__upload-container" (drop)="onDrop($event)" (dragover)="onDragover($event)">
      <div *ngIf="file.name; else uploadArea" class="upload-file__file-selected-container">
        <div>
          <span class="upload-file__file-name">{{ file.name }}</span>
          <span class="upload-file__remove-file ion-float-right" (click)="removeFile()">{{
            'upload_modal.Remove' | translate
          }}</span>
        </div>
      </div>
      <ng-template #uploadArea>
        <div class="upload-file__upload-card ion-text-center">
          <div>
            <img class="upload-file__upload-arrow-up" src="assets/common/arrow-up.svg" />
          </div>
          <div>
            <input type="file" class="upload-file__upload-file-input" (change)="onFileSelected($event)" #fileUpload />
            <div>
              <ui-custom-button
                [buttonType]="'SECONDARY'"
                [fontWeight]="'SEMIBOLD'"
                [btnTxt]="'upload_modal.Addfromcomputer' | translate"
                (clickEvent)="fileUpload.click()"
              ></ui-custom-button>
            </div>
          </div>
          <div class="upload-file__upload-card-subtitle">{{ 'upload_modal.ordraganddropthefiles' | translate }}</div>
        </div>
      </ng-template>
    </div>

    <div class="upload-file__action-btns">
      <span class="ion-margin-end">
        <ui-custom-button
          [buttonType]="'SECONDARY'"
          [btnTxt]="'upload_modal.Cancel' | translate"
          [buttonWidth]="'160px'"
          (clickEvent)="close()"
        ></ui-custom-button>
      </span>
      <span>
        <ui-custom-button
          [buttonType]="'PRIMARY'"
          [btnTxt]="'upload_modal.UploadFile' | translate"
          [buttonWidth]="'376px'"
          [isDisabled]="!file.name"
          (clickEvent)="uploadFile()"
        ></ui-custom-button>
      </span>
    </div>
  </div>
</div>
